import { STATE_LOGIN, STATE_SIGNUP } from './components/AuthForm';
import GAListener from './components/GAListener';
import { EmptyLayout, MainLayout } from './components/Layout';
import PageSpinner from './components/PageSpinner';
import Loading from './pages/AdminPage/pages/loading/Loading';
import AuthPage from './pages/AuthPage';
import React from 'react';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './styles/reduction.css';
import ProtectedRoutes from './pages/AdminPage/pages/protectedRoutes/ProtectedRoutes';

const AlertPage = React.lazy(() => import('./pages/AlertPage'));
const AuthModalPage = React.lazy(() => import('./pages/AuthModalPage'));
const BadgePage = React.lazy(() => import('./pages/BadgePage'));
const ButtonGroupPage = React.lazy(() => import('./pages/ButtonGroupPage'));
const ButtonPage = React.lazy(() => import('./pages/ButtonPage'));
const CardPage = React.lazy(() => import('./pages/CardPage'));
const ChartPage = React.lazy(() => import('./pages/ChartPage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const DropdownPage = React.lazy(() => import('./pages/DropdownPage'));
const FormPage = React.lazy(() => import('./pages/FormPage'));
const InputGroupPage = React.lazy(() => import('./pages/InputGroupPage'));
const ModalPage = React.lazy(() => import('./pages/ModalPage'));
const ProgressPage = React.lazy(() => import('./pages/ProgressPage'));
const TablePage = React.lazy(() => import('./pages/TablePage'));
const TypographyPage = React.lazy(() => import('./pages/TypographyPage'));
const WidgetPage = React.lazy(() => import('./pages/WidgetPage'));
// House routes
const AddHouse = React.lazy(() =>
  import('./pages/AdminPage/pages/House/AddHouse'),
);
const ViewHouse = React.lazy(() =>
  import('./pages/AdminPage/pages/House/ViewHouse'),
);
const UpdateHouse = React.lazy(() =>
  import('./pages/AdminPage/pages/House/UpdateHouse'),
);
const SingleHousePage = React.lazy(() =>
  import('./pages/AdminPage/pages/House/SingleHousePage'),
);
const MyHouse = React.lazy(() =>
  import('./pages/AdminPage/pages/House/MyHouse'),
);
//customer route
// const Customers = React.lazy(() =>
//   import('./pages/AdminPage/pages/Customers'),
// );
const UpdateUser = React.lazy(() =>
  import('./pages/AdminPage/pages/Users/UpdateUser'),
);
const ViewUser = React.lazy(() =>
  import('./pages/AdminPage/pages/Users/ViewUser'),
);
const SingleUser = React.lazy(() =>
  import('./pages/AdminPage/pages/Users/SingleUser'),
);
// const UserTransaction = React.lazy(() =>
//   import('./pages/AdminPage/pages/Users/UserTransaction'),
// );
const CompletProfile = React.lazy(() =>
  import('./pages/AdminPage/pages/Users/CompletProfile'),
);
// Agent routes
const AddAgent = React.lazy(() =>
  import('./pages/AdminPage/pages/Agent/AddAgent'),
);
const AllAgent = React.lazy(() =>
  import('./pages/AdminPage/pages/Agent/AllAgent'),
);
const UpdateAgent = React.lazy(() =>
  import('./pages/AdminPage/pages/Agent/UpdateAgent'),
);
//order route
const ViewComment = React.lazy(() =>
  import('./pages/AdminPage/pages/Comment/ViewComment'),
);
// const Settings = React.lazy(() => import('./pages/AdminPage/pages/Settings'));
// const ViewOrder = React.lazy(() =>
//   import('./pages/AdminPage/pages/Order/ViewOrder'),
// );
//analytics
const HouseSales = React.lazy(() =>
  import('./pages/AdminPage/pages/salesAnalytics/HouseAnalytics'),
);
//house category route
const HouseCategorys = React.lazy(() =>
  import('./pages/AdminPage/pages/House/HouseCategory'),
);
const AddHouseCategory = React.lazy(() =>
  import('./pages/AdminPage/pages/House/AddHouseCategory'),
);
const UpdateHouseCategory = React.lazy(() =>
  import('./pages/AdminPage/pages/House/UpdateHouseCategory'),
);
//news route
const CreateNews = React.lazy(() =>
  import('./pages/AdminPage/pages/News/CreateNews'),
);
const ViewNews = React.lazy(() =>
  import('./pages/AdminPage/pages/News/ViewNews'),
);
const UpdateNews = React.lazy(() =>
  import('./pages/AdminPage/pages/News/UpdateNews'),
);
const Favorite = React.lazy(() =>
  import('./pages/AdminPage/pages/Favorite/Favorite'),
);
const ViewRequest = React.lazy(() =>
  import('./pages/AdminPage/pages/Request/ViewTenantRequest'),
);
const ViewLandlordRequestPage = React.lazy(() =>
  import('./pages/AdminPage/pages/Request/ViewLandlordRequestPage'),
);

const SingleRequestPage = React.lazy(() =>
  import('./pages/AdminPage/pages/Request/SingleRequestPage'),
);
const SingleHouseRequestList = React.lazy(() =>
  import('./pages/AdminPage/pages/Request/SingleHouseRequestList'),
);
//Landing pages route
const HomePage = React.lazy(() => import('./pages/LandingPage/home/home'));
const Home = React.lazy(() => import('./pages/LandingPage/more/home'));
const News = React.lazy(() => import('./pages/LandingPage/news/news'));
const Search = React.lazy(() => import('./pages/LandingPage/search/search'));
const Rent = React.lazy(() => import('./pages/LandingPage/rent/rent'));
const Sale = React.lazy(() => import('./pages/LandingPage/sale/sale'));
const Booking = React.lazy(() => import('./pages/LandingPage/booking/booking'));

const Checkout = React.lazy(() =>
  import('./pages/LandingPage/checkout/Checkout'),
);
const HouseCategory = React.lazy(() =>
  import('./pages/LandingPage/houseCategory/houseCategory'),
);
const PrivacyPolicy = React.lazy(() =>
  import('./pages/LandingPage/PrivacyPolicy/PrivacyPolicy'),
);
const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

class App extends React.Component {
  render() {
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <React.Suspense fallback={<Loading />}>
            <Routes>
              {/* Public routes */}
              <Route
                path="/login"
                element={
                  <EmptyLayout>
                    <AuthPage authState={STATE_LOGIN} />
                  </EmptyLayout>
                }
              />
              <Route
                path="/signup"
                element={
                  <EmptyLayout>
                    <AuthPage authState={STATE_SIGNUP} />
                  </EmptyLayout>
                }
              />
              <Route path="/" element={<HomePage />} />
              <Route path="/more" element={<Home />} />
              <Route path="/news" element={<News />} />
              <Route path="/search/:houseName" element={<Search />} />
              <Route path="/rent" element={<Rent />} />
              <Route path="/sale-in-bahir-dar" element={<Sale />} />
              <Route
                path="/house-category/:cname"
                element={<HouseCategory />}
              />
              <Route path="/requesting/:id" element={<Booking />} />
              <Route path="/checkout/:id" element={<Checkout />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              {/* Main layout routes */}
              <Route element={<ProtectedRoutes />}>
                <Route
                  path="*"
                  element={
                    <MainLayout breakpoint={this.props.breakpoint}>
                      <Routes>
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route
                          path="/login-modal"
                          element={<AuthModalPage />}
                        />
                        <Route path="/buttons" element={<ButtonPage />} />
                        <Route path="/cards" element={<CardPage />} />
                        <Route path="/widgets" element={<WidgetPage />} />
                        <Route
                          path="/typography"
                          element={<TypographyPage />}
                        />
                        <Route path="/alerts" element={<AlertPage />} />
                        <Route path="/tables" element={<TablePage />} />
                        <Route path="/badges" element={<BadgePage />} />
                        <Route
                          path="/button-groups"
                          element={<ButtonGroupPage />}
                        />
                        <Route path="/dropdowns" element={<DropdownPage />} />
                        <Route path="/progress" element={<ProgressPage />} />
                        <Route path="/modals" element={<ModalPage />} />
                        <Route path="/forms" element={<FormPage />} />
                        <Route
                          path="/input-groups"
                          element={<InputGroupPage />}
                        />
                        <Route path="/charts" element={<ChartPage />} />

                        {/* House routes */}
                        <Route path="/all-house" element={<ViewHouse />} />
                        <Route path="/add-house" element={<AddHouse />} />
                        <Route
                          path="/update-house/:id"
                          element={<UpdateHouse />}
                        />
                        <Route
                          path="/single-house/:id"
                          element={<SingleHousePage />}
                        />
                        <Route path="/my-house" element={<MyHouse />} />
                        {/* customer routes */}
                        <Route path="/customers" element={<ViewUser />} />
                        <Route
                          path="/single-user/:id"
                          element={<SingleUser />}
                        />
                        <Route
                          path="/updateUser/:id"
                          element={<UpdateUser />}
                        />
                        <Route path="/profile" element={<CompletProfile />} />

                        {/* agent routes */}
                        <Route path="/add-agent" element={<AddAgent />} />
                        <Route path="/all-agent" element={<AllAgent />} />
                        <Route
                          path="/update-agent/:id"
                          element={<UpdateAgent />}
                        />

                        <Route
                          path="/view-feedback"
                          element={<ViewComment />}
                        />
                        {/* <Route path="/setting" element={<Settings />} /> */}
                        <Route path="/house-sales" element={<HouseSales />} />

                        {/* news routes */}
                        <Route path="/add-news" element={<CreateNews />} />
                        <Route path="/view-news" element={<ViewNews />} />
                        <Route
                          path="/update-news/:id"
                          element={<UpdateNews />}
                        />

                        {/* house category routes */}
                        <Route
                          path="/house-category"
                          element={<HouseCategorys />}
                        />
                        <Route
                          path="/update-category/:id"
                          element={<UpdateHouseCategory />}
                        />
                        <Route
                          path="/add-category"
                          element={<AddHouseCategory />}
                        />
                        <Route path="/favorites" element={<Favorite />} />
                        <Route
                          path="/requests"
                          element={<ViewLandlordRequestPage />}
                        />
                        <Route path="/request" element={<ViewRequest />} />
                        <Route
                          path="/single-request/:id"
                          element={<SingleRequestPage />}
                        />
                        <Route
                          path="/single-house-request/:id"
                          element={<SingleHouseRequestList />}
                        />
                        {/* Fallback redirect */}
                        <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                    </MainLayout>
                  }
                />
              </Route>
            </Routes>
          </React.Suspense>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) return { breakpoint: 'xs' };
  if (576 < width && width < 767) return { breakpoint: 'sm' };
  if (768 < width && width < 991) return { breakpoint: 'md' };
  if (992 < width && width < 1199) return { breakpoint: 'lg' };
  if (width > 1200) return { breakpoint: 'xl' };
  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
